import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import { Stack, Typography } from '@mui/material';
import React from 'react';

export default function ChartEmptyState() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} height="100%" fontSize={48} color="text.disabled">
      <InsertChartOutlinedIcon fontSize="inherit" />
      <Typography variant="body2" color="text.secondary">
        No data for the selected period
      </Typography>
    </Stack>
  );
}
